<div class="inline-block border border-solid border-grey-200 bg-white shadow-md">
  <div class="pb-3 pl-4 pr-1.5 pt-1.5">
    <div class="flex items-center">
      <div id="checklist-title" class="grow text-base font-semibold text-word-mark-800">{{ title }}</div>
      <div class="flex gap-1">
        <button (click)="onMinimize()" sb-icon-button [color]="'transparent'" [size]="'base'">
          <sb-icon [name]="'chevron-down'" />
        </button>
        <button (click)="onClose()" sb-icon-button [color]="'transparent'" [size]="'base'">
          <sb-icon [name]="'times'" />
        </button>
      </div>
    </div>
    <div id="checklist-subtitle" class="text-sm text-word-mark-600">{{ subtitle }}</div>
  </div>

  <hr class="m-0 mb-4 w-full max-w-5xl border-t border-solid border-grey-200" />

  @if (progress) {
    <div class="mx-4 mb-4 w-96">
      <sb-progress-bar [title]="progress.title" [subtitle]="progress.subtitle" [level]="progress.level" />
    </div>
  }

  @for (item of items; track item.title; let last = $last) {
    <div class="mx-1.5" [ngClass]="last ? 'mb-6' : 'mb-2.5'">
      <sb-legacy-checklist-item
        [title]="item.title"
        [isCompleted]="item.isCompleted"
        (clicked)="onItemClick(item.action)"
      />
    </div>
  }
</div>
